<template>
    <section>
        <b-alert v-if="error" show variant="danger">{{ error }}</b-alert>
        <p v-if="!loading && !events.length && !error" class="text-muted">Изменений этой ставки в новой системе пока нет.</p>
        <article v-for="event in events" :key="event.id" class="rate-change">
            <strong>{{ label(event.change_kind) }}</strong>
            <div class="small text-muted">{{ dateTime(event.occurred_at) }} · {{ event.actor_name }}</div>
            <div v-if="event.before" class="mt-2"><span class="text-muted">Было: </span>{{ describe(event.before) }}</div>
            <div><span class="text-muted">Стало: </span>{{ describe(event.after) }}</div>
            <small class="d-block">Действует {{ range(event.after) }}</small>
        </article>
        <p v-if="loading" role="status"><b-spinner small /> Загружаем историю…</p>
        <b-button v-if="nextId || error" variant="outline-secondary" :disabled="loading" @click="load">{{ error ? 'Повторить' : 'Показать ещё' }}</b-button>
        <template v-if="historicalRates.length">
            <h3 class="h6 mt-4">Архивные ставки по месяцам</h3>
            <p class="small text-muted">Значения из исходных таблиц. Разные варианты одного месяца показаны отдельно; отсутствие ставки не заменяется нулём.</p>
            <article v-for="row in historicalRates" :key="row.id" class="rate-change">
                <strong>{{ row.period_start.slice(0, 7) }} · {{ Number(row.value).toLocaleString('ru-RU') }} {{ row.currency }} / {{ {hour: 'час', day: 'день', month: 'месяц'}[row.basis] || 'единица не указана' }}</strong>
                <div>{{ {base: 'База', object: 'Объекты', any: 'Любое место'}[row.location_class] }}<span v-if="row.object_name"> · {{ row.object_name }}</span></div>
                <div class="small text-muted">{{ row.source_name }} · столбец {{ row.column }}<span v-if="row.source_row"> · строка {{ row.source_row }}</span></div>
                <a v-if="row.source_url" :href="row.source_url" target="_blank" rel="noopener noreferrer">Исходная таблица ↗</a>
            </article>
        </template>
    </section>
</template>
<script>
import api from '@/utils/api';
export default {
    name: 'PayrollRateChanges',
    props: {termId: {type: Number, required: true}},
    data: () => ({events: [], historicalRates: [], nextId: null, error: '', loading: false, version: 0}),
    watch: {termId() { this.events = []; this.historicalRates = []; this.nextId = null; this.load(); }},
    mounted() { this.load(); },
    beforeDestroy() { this.version++; },
    methods: {
        label(value) { return {created: 'Ставка задана', new_period: 'Ставка на новый период', correction: 'Исправление ставки'}[value] || 'Изменение ставки'; },
        dateTime(value) { return value ? new Date(value).toLocaleString('ru-RU') : ''; },
        range(value) { return `с ${value.effective_from}${value.effective_to ? ' по ' + value.effective_to : ', без окончания'}`; },
        describe(value) {
            const policy = value.policy || {}, unit = {hourly: 'час', daily: 'день', monthly: 'месяц'}[policy.basis] || '';
            return `${(value.rate_minor / 100).toLocaleString('ru-RU', {minimumFractionDigits: 2})} ${policy.currency || ''}${unit ? ' / ' + unit : ''} · коэффициент ${value.coefficient_bp / 10000}`;
        },
        async load() {
            const version = ++this.version;
            this.loading = true; this.error = '';
            try {
                const {data} = await api.get(`/api/payroll/catalog/terms/${this.termId}/history`, {params: {before_id: this.nextId || undefined}, ignoreModal: true});
                if (version !== this.version) return;
                this.events = this.events.concat(data.events); this.nextId = data.next_before_id;
                if (data.historical_rates) this.historicalRates = data.historical_rates;
            } catch (error) {
                if (version === this.version) this.error = error && error.response && error.response.data && error.response.data.msg || 'Не удалось загрузить историю ставки.';
            } finally { if (version === this.version) this.loading = false; }
        }
    }
};
</script>
<style scoped>
.rate-change { padding: 12px 0; border-bottom: 1px solid #dee2e6; }
.rate-change:last-of-type { margin-bottom: 16px; }
</style>
